// extracted by mini-css-extract-plugin
export default {"validationErrors":"SoapUser_validationErrors__Yz8PF","alertBox":"SoapUser_alertBox__jxwSf","errorAlert":"SoapUser_errorAlert__sAWN7","warningAlert":"SoapUser_warningAlert__QyI01"};